/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useEffect, useRef, useState} from 'react';
import ScrollToTop from "../../layouts/ScrollToTop";
import {Link, Navigate, useNavigate, useParams} from "react-router-dom";
import {ReactComponent as CheckboxEmpty} from "../../assets/img/forms/checkbox-empty.svg";
import {ReactComponent as CheckboxFull} from "../../assets/img/forms/checkbox-full.svg";
import {useForm} from "react-hook-form";
import ReactFlagsSelect from "react-flags-select";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {useTranslation} from "react-i18next";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import {PayPalScriptProvider} from "@paypal/react-paypal-js";
import ButtonWrapper from "./PaypalButton";
import CheckoutHeader from "./CheckoutHeader";
import CheckoutHeadLabels from "./CheckoutHeadLabels";
import CheckoutSummary from "./CheckoutSummary";
import CheckoutBackLink from "./CheckoutBackLink";
import {useAuth} from "../../Hooks/useAuth";
import SEO from "../../components/SEO";

const Checkout = () => {

    return <Navigate to="/" replace />;

    const user = useAuth();
    const axiosJWT = useAxiosJTW();
    let params = useParams();
    let navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const [paymentMethods, setPaymentMethods] = useState([]);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');


    const [userData, setUserData] = useState({});
    const [cities, setCities] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState("AT");
    const [phoneCode, setPhoneCode] = useState();

    const [editField, setEditField] = useState(true);
    const [stepOneActive, setStepOneActive] = useState(true);
    const [stepTwoActive, setStepTwoActive] = useState(false);
    const [stepThreeActive, setStepThreeActive] = useState(false);
    const [stepOneOpened, setStepOneOpened] = useState(true);
    const [stepTwoOpened, setStepTwoOpened] = useState(false);
    const [stepThreeOpened, setStepThreeOpened] = useState(false);
    const [userRegisterError, setUserRegisterError] = useState(false);

    const [pack, setPack] = useState(false);
    const [isFreePack, setIsFreePack] = useState(false);
    const [payPalDetails, setPayPalDetails] = useState({});
    const [payPalError, setPayPalError] = useState(false);

    const [success, setSuccess] = useState(false);

    const scrollToFormRef = useRef(null);
    const scrollToPaymentRef = useRef(null);
    const scrollToReviewRef = useRef(null);

    const { control, getValues, setError, register, handleSubmit, watch, formState: { errors }, trigger, clearErrors, setValue } = useForm({
        mode: "onChange",
        defaultValues:{
            email: '',
            confirm: ''
        }
    });

    const watchPaymentMethod = watch("paymentMethod", false);
    const watchApproveTerms = watch("approve", false);
    let selectedTerms = () => (watchApproveTerms);

    const onSelectCountry = (code) => {
        const controller = new AbortController();
        const signal= controller.signal;

        setSelectedCountry(code);
        setValue('country', code, { shouldValidate: true });
        getCities(code, signal);
    };
    const onPhoneCodeChange = (value, data, event, formattedValue) => {
        setPhoneCode(value);
        setValue('phoneCode', value, { shouldValidate: true });
    }
    const getPack = (price_id, signal) =>{
        axiosJWT.post('api/getpack', {pack: price_id}, {signal}).then((response) => {

            if(response.status === 200){
                setPack(response.data.subscriptions[0] || []);
                if(response.data.subscriptions[0].price === '0.00'){
                    setIsFreePack(true);
                    setSelectedPaymentMethod('7 days free trial');
                }else{
                    setSelectedPaymentMethod('PAYPAL');
                }

            }

        }).catch((error) => {
            console.log(error);
        });
    }
    const getCities = (country, signal) =>{
        axiosJWT.post('api/getcities',{country: country},  {signal}).then( (response) => {
            if(response.status === 200){
                setCities(response.data.cities);
            }
        } ).catch((error) => {
            console.log(error);
        });
    }


    const checkemail = (data) =>{
        setUserRegisterError(false);
        axiosJWT.post('api/checkemail', data).then( (response)=>{

            //ok            success, paymentmethods.
            //merchant      error 4  Email already exists
            //user          error 3   user_id,  paymentmethods Email already exists
            if(response.data.error == 4){
                setError("email", { type: "unique", message:"Email already exists" }, { shouldFocus: true });
                return;
            }

            if(response.data.success ){

                setEditField(false);
                setPaymentMethods(response.data.payments_methods || []);
                if(document.documentElement.scrollIntoView){
                    scrollToPaymentRef.current?.scrollIntoView({behavior: 'smooth', block: "center", inline: "nearest"});
                }
                setStepTwoOpened(true);
                setStepTwoActive(true);

            }

            if( response.data.success && response.data.user_id){

                setUserData(userData => ({
                    ...userData,
                    user_id: response.data.user_id
                }));

            }


        }).catch((error) => {
            console.log(error);
            setUserRegisterError(true);
        });
    }

    const userRegister = (data) =>{

        setSuccess(false);
        setUserRegisterError(false);

        const orderData = {
            fname: getValues("fname"),
            lname: getValues("lname"),
            email: getValues("email"),
            password: getValues("password"),
            address: getValues("address"),
            postalcode: getValues("postalcode"),
            city: getValues("city"),
            phone: getValues("phone"),
            phone_code: getValues("phoneCode"),
            country: getValues("country"),
            companyname: getValues("companyname"),
            vat: getValues("vat"),
            group_id: 3,
            terms : getValues("approve"),
            paymentMethod: getValues("paymentMethod"),
            user_id: userData.user_id,
            subscription_price_id: userData.subscription_price_id,
            transaction: data || null
        }

        axiosJWT.post('api/register', orderData).then( (response) => {

            if(response.data.success && response.data.user_register){

                setStepOneOpened(false);
                setStepTwoOpened(false);
                setStepThreeActive(true);
                setStepThreeOpened(true);
                setSuccess(true);

                if(document.documentElement.scrollIntoView){
                    setTimeout(function (){
                        scrollToReviewRef.current?.scrollIntoView({behavior: 'smooth', block: "center", inline: "nearest"});
                    }, 300);

                }
            }

        } ).catch((error) => {
            console.log(error);
            setUserRegisterError(true);
        });

    }

    const submitStepOne = async () =>{
        try{
            const _trigger = await trigger(['fname', 'lname', 'email','password', 'address', 'postalcode', 'city', 'phone', 'phoneCode', 'country', 'companyname', 'vat' ]);

            if(_trigger){

                const queryParameters = new URLSearchParams(window.location.search);
                const _price_id = queryParameters.get("price_id");

                setUserData({
                    fname: getValues("fname"),
                    lname: getValues("lname"),
                    email: getValues("email"),
                    password: getValues("password"),
                    address: getValues("address"),
                    postalcode: getValues("postalcode"),
                    city: getValues("city"),
                    phone: getValues("phone"),
                    phone_code: getValues("phoneCode"),
                    country: getValues("country"),
                    companyname: getValues("companyname"),
                    vat: getValues("vat"),
                    group_id: 3,
                    terms : getValues("approve"),
                    paymentMethod: getValues("paymentMethod"),  //2
                    user_id: null,                            //an yparxei
                    subscription_price_id: _price_id,           //to  paketo
                    transaction: null                          //paypal object
                });


                // const city = getValues("city");
                // const currentCity = cities.find(option => option.id === city);
                // console.log( currentCity );

                checkemail({email: getValues("email"), country:getValues("country") });
            }
        }catch (e) {

        }
    }
    const editStepOne = () =>{
        setEditField(true);
        setStepTwoOpened(false);
        setStepTwoActive(false);
        setUserRegisterError(false);
        if(document.documentElement.scrollIntoView){
            scrollToFormRef.current?.scrollIntoView({behavior: 'smooth', block: "start", inline: "nearest"});
        }
        setValue("paymentMethod", '');
        setPaymentMethods([]);
    }

    const submitStepTwo = () => {
        userRegister(null);
    }
    const onSubmit = data => {
        //console.log(data);
    };

    useEffect(() => {
        const controller = new AbortController();
        const signal= controller.signal;

        const queryParameters = new URLSearchParams(window.location.search);
        const _price_id = queryParameters.get("price_id");
        if(!_price_id){
            navigate(`/${i18n.language}/pricing`);
            return ;
        }

        getPack(_price_id, signal);

        setUserData(userData => ({
            ...userData,
            subscription_price_id: _price_id
        }));

        const _country= getValues("country");
        getCities(_country, signal);

        return () => {controller.abort();}
    }, [params]);

    useEffect(() => {

        if(payPalDetails.status === 'COMPLETED'){

            setUserData(userData => ({
                ...userData,
                transaction: payPalDetails
            }));

            userRegister(payPalDetails);

        }

    }, [payPalDetails]);

    return (
        <ScrollToTop>
            <SEO
                title={ t('meta_title.checkout' )}
                description={ t('meta_description.checkout' ) }
            />
            <div className='page-box page-box--checkout'>
                <CheckoutHeader stepOneActive={stepOneActive} stepTwoActive={stepTwoActive} stepThreeActive={stepThreeActive} />
                <div className='page-box__body'>
                    <div className='container container-checkout'>

                        <CheckoutBackLink />

                        <div className='checkout__body'>
                            <div className='row gutters-10'>
                                <div className='col-md-7'>

                                    <form onSubmit={handleSubmit(onSubmit)}>

                                        <div className={`checkoutBox ${stepOneOpened ? 'opened' : ''}`} ref={scrollToFormRef}>

                                            <CheckoutHeadLabels num={1} title={t('checkout.accountDetails')} account={false} />

                                            {user.profile.group_id == 2 || user.profile.group_id == 3 ? (
                                                <div className='checkoutBox__body'>
                                                    <div className='mb-1'>Είστε συνδεδεμένος ως&nbsp;{user.profile.fname}&nbsp;{user.profile.lname}</div>
                                                    <div className='mb-3'>
                                                        <a href='#' className='simple-link' onClick={ (e) => { user.linkToDashBoard(); } }>Διαχειριστείτε τα πακλετα σας</a>
                                                    </div>
                                                    <div>
                                                        <a href='#' className='simple-link' onClick={ (e) => { user.logOut(); } }>Logout</a>
                                                    </div>

                                                </div>
                                            ) : (
                                                <>
                                                    <div className={`checkoutBox__body ${!editField ? 'fogged' : ''} `}>
                                                        <div className='checkoutBox__body-inner'>

                                                            <div className='checkoutBox__small-title'>{t('checkout.userDetails')}</div>

                                                            <div className='row small-gutters'>
                                                                <div className="form-group col-md-6">
                                                                    <label htmlFor="fname">{t('checkout.firstName')}*</label>
                                                                    <input id="fname" type="text" className="form-control" readOnly={!editField} {...register("fname", {required: 'Required Field'})}/>
                                                                    { errors.fname && <small className="text-danger">{errors.fname?.message}</small>}
                                                                </div>
                                                                <div className="form-group col-md-6">
                                                                    <label htmlFor="lname">{t('checkout.lastName')}*</label>
                                                                    <input id="lname" type="text" className="form-control" {...register("lname", {required: 'Required Field'})}/>
                                                                    { errors.lname && <small className="text-danger">{errors.lname?.message}</small>}
                                                                </div>
                                                            </div>

                                                            <div className='row small-gutters'>
                                                                <div className="form-group col-md-6">
                                                                    <label htmlFor="email">{t('checkout.email')}*</label>
                                                                    <input id="email" type="email" className="form-control" {...register("email", {
                                                                        required: 'Required Field',
                                                                        pattern: {
                                                                            // value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                                            value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                                                                            message: 'Please enter a valid email',
                                                                        }

                                                                    })}/>
                                                                    { errors.email && <small className="text-danger">{errors.email?.message}</small>}
                                                                </div>
                                                                <div className="form-group col-md-6">
                                                                    <label htmlFor="password">{t('checkout.password')}</label>
                                                                    <input id="password" type="password" className="form-control" {...register("password", {
                                                                        required: 'Required Field',
                                                                        minLength: {
                                                                            value: 8,
                                                                            message: 'At least 8 digits'
                                                                        },
                                                                    })}/>
                                                                    { errors.password && <small className="text-danger">{errors.password?.message}</small>}
                                                                </div>
                                                            </div>

                                                            <div className='checkoutBox__small-title'>{t('checkout.billingDetails')}</div>

                                                            <div className='row small-gutters'>
                                                                <div className="form-group col-md-6">
                                                                    <label htmlFor="address">{t('checkout.address')}</label>
                                                                    <input id="address" type="text" className="form-control" {...register("address", {
                                                                        required: 'Required Field'
                                                                    })}/>
                                                                    { errors.address && <small className="text-danger">{errors.address?.message}</small>}
                                                                </div>
                                                                <div className="form-group col-md-6">
                                                                    <label htmlFor="postalcode">{t('checkout.postalCode')}</label>
                                                                    <input id="postalcode" type="text" className="form-control" {...register("postalcode", {
                                                                        required: 'Required Field',
                                                                        minLength: {
                                                                            value: 4,
                                                                            message: 'At least 4 digits'
                                                                        },
                                                                    })}/>
                                                                    { errors.postalcode && <small className="text-danger">{errors.postalcode?.message}</small>}
                                                                </div>
                                                            </div>

                                                            <div className='row small-gutters'>
                                                                <div className="form-group col-md-6">
                                                                    <label htmlFor="city">{t('checkout.city')}</label>
                                                                    <select id="city" defaultValue={''} className="form-control" options={cities} {...register("city", {required: 'Required Field'})}>
                                                                        <option value="" disabled>{t('checkout.select')}</option>
                                                                        {Array.isArray(cities) && cities.map((option, i) => <option key={i} value={option.id}>{option.description}</option>)}
                                                                    </select>
                                                                    { errors.city && <small className="text-danger">{errors.city?.message}</small>}
                                                                </div>
                                                                <div className="form-group col-md-6">
                                                                    <label htmlFor="phone">{t('checkout.telephone')}</label>
                                                                    <div className='position-relative codePhone'>
                                                                        <input id="phone" type="text" className="form-control codePhone__number" {...register("phone", {
                                                                            required: 'Required Field',
                                                                            pattern: {
                                                                                value: /^(0|[1-9]\d*)(\.\d+)?$/,
                                                                                message: "Numbers only"
                                                                            },
                                                                            minLength: {
                                                                                value: 9,
                                                                                message: 'At least 9 digits'
                                                                            },
                                                                            maxLength: {
                                                                                value: 13,
                                                                                message: 'At most 13 digits'
                                                                            },
                                                                        })}/>
                                                                        <input id="phoneCode" type="hidden" className="form-control" value={'43'} {...register("phoneCode", {
                                                                            required: 'Country code is required',
                                                                        })}/>
                                                                        <PhoneInput
                                                                            country={"at"}
                                                                            enableSearch={true}
                                                                            value={phoneCode}
                                                                            autoFormat={false}
                                                                            placeholder={''}
                                                                            inputClass={''}
                                                                            regions={'europe'}
                                                                            onChange={onPhoneCodeChange}
                                                                            inputProps={{
                                                                                disabled: true
                                                                            }}
                                                                        />
                                                                        { errors.phoneCode && <small className="text-danger">{errors.phoneCode?.message}</small>}
                                                                        { errors.phone && <small className="text-danger codePhone__number-error">{errors.phone?.message}</small>}
                                                                    </div>

                                                                </div>
                                                            </div>

                                                            <div className='row small-gutters'>
                                                                <div className="form-group col-md-6">
                                                                    <label htmlFor="country">{t('checkout.country')}</label>
                                                                    <input type='hidden' defaultValue={selectedCountry} {...register("country", {required: 'Required Field'})}/>
                                                                    <ReactFlagsSelect
                                                                        selected={selectedCountry}
                                                                        onSelect={onSelectCountry}
                                                                        searchable
                                                                        className='form-control--country'
                                                                        countries={["AT", "DE", "PL", "CH", "CZ", "SI"]}
                                                                        // showSelectedLabel={showSelectedLabel}
                                                                        // selectedSize={selectedSize}
                                                                        // showOptionLabel={showOptionLabel}
                                                                        // optionsSize={optionsSize}
                                                                        // placeholder={placeholder}
                                                                        // searchable={searchable}
                                                                        // searchPlaceholder={searchPlaceholder}
                                                                        // alignOptionsToRight={alignOptionsToRight}
                                                                        fullWidth={true}
                                                                        showSelectedLabel={true}
                                                                        showSecondarySelectedLabel={true}
                                                                        // customLabels={{
                                                                        //     "US": { primary: "EN-US", secondary: "+1" },
                                                                        //     "GB": { primary: "EN-GB", secondary: "+44" },
                                                                        //     "FR": "FR"
                                                                        // }}
                                                                    />

                                                                    { errors.country && <small className="text-danger">{errors.country?.message}</small>}
                                                                </div>
                                                                <div className="form-group col-md-6">

                                                                </div>
                                                            </div>

                                                            <div className='row small-gutters'>
                                                                <div className="form-group col-md-6">
                                                                    <label htmlFor="companyname">{t('checkout.companyTradeName')}</label>
                                                                    <input id="companyname" type="text" className="form-control"  {...register("companyname", {required: 'Required Field'})}/>
                                                                    { errors.companyname && <small className="text-danger">{errors.companyname?.message}</small>}
                                                                </div>
                                                                <div className="form-group col-md-6">
                                                                    <label htmlFor="vat">{t('checkout.vat')}</label>
                                                                    <input id="vat" type="text" className="form-control"  {...register("vat", {
                                                                        required: 'Required Field',
                                                                        maxLength: {
                                                                            value: 11,
                                                                            message: 'Max 11 digits'
                                                                        },
                                                                    })}/>
                                                                    { errors.vat && <small className="text-danger">{errors.vat?.message}</small>}
                                                                </div>
                                                            </div>

                                                            <div className='checkoutBox--sep'></div>

                                                            {userRegisterError && <div className="alert alert-danger" role="alert">
                                                                something went wrong please try again
                                                            </div>}
                                                        </div>
                                                        {editField ? (
                                                            <div className='btn btn-primary btn--step' onClick={ submitStepOne }>{t('checkout.continue')}</div>
                                                        ) : (
                                                            <div className='btn btn-primary btn--step' onClick={ editStepOne }>{t('checkout.edit')}</div>
                                                        )}
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        <div className={`checkoutBox ${ stepTwoOpened ? "opened" : ""}`} ref={scrollToPaymentRef}>

                                            <CheckoutHeadLabels num={2} title={t('checkout.payment')} account={false} lock={true} />
                                            <div className='checkoutBox__body'>

                                                {/*<div className=''>Select a payment method</div>*/}
                                                {/*<div className='pt-2 mb-2'>*/}
                                                {/*    { errors.paymentMethod && <div className="text-danger">{errors.paymentMethod?.message}</div>}*/}
                                                {/*</div>*/}
                                                {/*<div className='checkoutBox--sep'></div>*/}

                                                {isFreePack ? (
                                                    <div className='boxes-wrap'>
                                                        <div className='checkoutRadio' style={{width: '100%'}}>
                                                            <div className='checkoutRadio__row'>
                                                                <span className='checkoutRadio__label'>{t('checkout.freeTrial')}</span>
                                                            </div>
                                                            <span className='checkoutRadio__text'>{t('checkout.startWithFree')}</span>
                                                            <div className='pt-3'>
                                                                <label className="custom-checkbox">
                                                                    <input type="checkbox" className="" value="1" {...register("approve", {required: 'Required Field'} )}/>
                                                                    <span className="custom-checkbox__icon custom-checkbox__empty"><CheckboxEmpty/></span>
                                                                    <span className="custom-checkbox__icon custom-checkbox__checked"><CheckboxFull/></span>
                                                                    {/*<div>Checking here and continuing, I agree to the <strong>&nbsp;AutoRec&nbsp;</strong> <Link to={`/${i18n.language}/terms`} target="_blank"> Terms of Use. </Link></div>*/}
                                                                    <div>{t('checkout.checking')}</div>
                                                                </label>
                                                            </div>
                                                            <input type="hidden" {...register("paymentMethod", {required: 'Please select Payment method'} )} value={'2'}/>
                                                            <div className={`pt-3 ${ selectedTerms() ? "" : "d-none"}`}>
                                                                <button className='btn btn-primary btn--step' onClick={submitStepTwo}>{t('checkout.startTrial')}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='boxes-wrap'>
                                                        <div className='checkoutRadio' style={{width: '100%'}}>
                                                            <div className='checkoutRadio__row'>
                                                                <span className='checkoutRadio__label'>PAYPAL</span>
                                                            </div>
                                                            <span className='checkoutRadio__text'>{t('checkout.safer')}</span>
                                                            <div className='pt-3'>
                                                                <label className="custom-checkbox">
                                                                    <input type="checkbox" className="" value="1" {...register("approve", {required: 'Required Field'} )}/>
                                                                    <span className="custom-checkbox__icon custom-checkbox__empty"><CheckboxEmpty/></span>
                                                                    <span className="custom-checkbox__icon custom-checkbox__checked"><CheckboxFull/></span>
                                                                    {/*<div>Checking here and continuing, I agree to the <strong>&nbsp;AutoRec&nbsp;</strong> <Link to={`/${i18n.language}/terms`} target="_blank"> Terms of Use. </Link></div>*/}
                                                                    <div>{t('checkout.checking')}</div>
                                                                </label>
                                                            </div>
                                                            <input type="hidden" {...register("paymentMethod", {required: 'Please select Payment method'} )} value={'2'}/>
                                                            <div className='pt-3'>
                                                                <div className={`${ selectedTerms() ? "" : "paypalOverlay"}`}>
                                                                    <PayPalScriptProvider
                                                                        options={{
                                                                            "client-id": `${process.env.REACT_APP_PAYPAL_CLIENT_ID}`,
                                                                            components: "buttons",
                                                                            currency: "EUR"
                                                                        }}
                                                                    >
                                                                        <ButtonWrapper
                                                                            amount={pack.price}
                                                                            currency={"EUR"}
                                                                            showSpinner={false}
                                                                            onPayPalApprove={setPayPalDetails}
                                                                            onPayPalError={setPayPalError}
                                                                        />
                                                                    </PayPalScriptProvider>
                                                                </div>
                                                            </div>

                                                            {payPalError && <div className="alert alert-danger" role="alert">
                                                                something went wrong please try again
                                                            </div>}
                                                            {userRegisterError && <div className="alert alert-danger" role="alert">
                                                                something went wrong please try again
                                                            </div>}

                                                        </div>
                                                    </div>
                                                )}

                                                {/*{Array.isArray(paymentMethods) && paymentMethods.map( (method, index) =>(*/}
                                                {/*    <label className='checkoutRadio' key={index} style={{width: '100%'}}>*/}
                                                {/*        <div className='checkoutRadio__row'>*/}
                                                {/*            <span className="custom-radio">*/}
                                                {/*                <input type="radio" {...register("paymentMethod", {required: 'Please select Payment method'} )} value={method.payments_method_id}/>*/}
                                                {/*                <span></span>*/}
                                                {/*            </span>*/}
                                                {/*            <span className='checkoutRadio__label'>*/}
                                                {/*            {method.title}*/}
                                                {/*        </span>*/}
                                                {/*        </div>*/}
                                                {/*        <span className='checkoutRadio__text'>*/}
                                                {/*            <div className='mb-3'>{method.description}</div>*/}
                                                {/*        </span>*/}
                                                {/*    </label>*/}
                                                {/*) )}*/}


                                            </div>

                                        </div>

                                        <div className={`checkoutBox ${ stepThreeOpened ? "opened" : ""}`} ref={scrollToReviewRef}>

                                            <CheckoutHeadLabels num={3} title={t('checkout.review')} lock={false} />
                                            <div className='checkoutBox__body'>

                                                <div className='text--title mb-3'>{t('checkout.yourSubscription')}</div>
                                                <div className='Individual'>{pack.title}</div>
                                                <div className='checkoutBox--sep mt-4 mb-4'></div>

                                                <div className='text--title mb-3'>{t('checkout.yourAccountInfo')}</div>
                                                <div className='accountInfoTable mb-3'>
                                                    <div className='accountInfoTable__row'>
                                                        <div className='accountInfoTable__label'>{t('checkout.firstName')}</div>
                                                        <div className='accountInfoTable__value'>{ getValues("fname") }</div>
                                                    </div>
                                                    <div className='accountInfoTable__row'>
                                                        <div className='accountInfoTable__label'>{t('checkout.lastName')}</div>
                                                        <div className='accountInfoTable__value'>{ getValues("lname") }</div>
                                                    </div>
                                                    <div className='accountInfoTable__row'>
                                                        <div className='accountInfoTable__label'>{t('checkout.email')}</div>
                                                        <div className='accountInfoTable__value'>{ getValues("email") }</div>
                                                    </div>
                                                    <div className='accountInfoTable__row'>
                                                        <div className='accountInfoTable__label'>{t('checkout.telephone')}</div>
                                                        <div className='accountInfoTable__value'>{ getValues("phone") }</div>
                                                    </div>
                                                    <div className='accountInfoTable__row'>
                                                        <div className='accountInfoTable__label'>{t('checkout.country')}</div>
                                                        <div className='accountInfoTable__value'>{selectedCountry}</div>
                                                    </div>
                                                    <div className='accountInfoTable__row'>
                                                        <div className='accountInfoTable__label'>{t('checkout.city')}</div>
                                                        <div className='accountInfoTable__value'>
                                                            {Array.isArray(cities) && cities.map((option, i) => {
                                                                    if ( option.id == getValues("city")){
                                                                        return (
                                                                            <span key={i}>{option.description}</span>
                                                                        )
                                                                    }

                                                                }
                                                            ) }
                                                        </div>
                                                    </div>
                                                    {getValues("address") && <div className='accountInfoTable__row'>
                                                        <div className='accountInfoTable__label'>{t('checkout.address')}</div>
                                                        <div className='accountInfoTable__value'>{ getValues("address") }</div>
                                                    </div>}
                                                    <div className='accountInfoTable__row'>
                                                        <div className='accountInfoTable__label'>{t('checkout.postalCode')}</div>
                                                        <div className='accountInfoTable__value'>{ getValues("postalcode") }</div>
                                                    </div>
                                                    <div className='accountInfoTable__row'>
                                                        <div className='accountInfoTable__label'>{t('checkout.companyTradeName')}</div>
                                                        <div className='accountInfoTable__value'>{ getValues("companyname") }</div>
                                                    </div>
                                                    <div className='accountInfoTable__row'>
                                                        <div className='accountInfoTable__label'>{t('checkout.vat')}</div>
                                                        <div className='accountInfoTable__value'>{ getValues("vat") }</div>
                                                    </div>
                                                </div>

                                                <div className='checkoutBox--sep mt-4 mb-4'></div>

                                                <div className='text--title mb-3'>{t('checkout.paymentMethod')}</div>
                                                <div>{selectedPaymentMethod}</div>
                                                <div className='checkoutBox--sep mt-4 mb-4'></div>

                                                <div className='checkoutBox__note'>{t('checkout.weWill')}</div>

                                                <div className='checkoutBox__footer'>

                                                    {success && <div className="alert alert-success" role="alert">
                                                        <p className="font-weight-bold mb-1">{t('checkout.succesfullyRegistered')}</p>
                                                        <p>{t('checkout.Wehavesent')}</p>
                                                        <p><Link to={`/${i18n.language}/login`} className='alert-link'>{t('checkout.pleaselogin')}</Link></p>
                                                    </div>}

                                                    {userRegisterError && <div className="alert alert-danger" role="alert">
                                                        something went wrong please try again
                                                    </div>}

                                                </div>

                                            </div>

                                        </div>
                                    </form>

                                </div>
                                <div className='col-md-5'>

                                    <CheckoutSummary pack={pack} />

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </ScrollToTop>
    );
};

export default Checkout;
